import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useServiceWorkerPersistedStore = create()(
  persist(
    devtools(() => ({
      isCacheCleared: false,
    })),
    {
      name: "service-worker-persisted-store",
    }
  )
);
